module.exports = __webpack_public_path__ + "img/foodtype-american.9c3d42ec.png";